import request from './http';

const login = body => {
  return request({
    method: 'POST',
    url: `users/users/sign-in`,
    data: { ...body },
  });
};

const registerEntity = data => {
  return request({
    method: 'POST_FORMDATA',
    url: `users/entities/send-registration-request`,
    data: objectToFormData(data),
  });
};

const objectToFormData = data => {
  const formData = new FormData();

  for (let property in data) {
    if (Object.prototype.hasOwnProperty.call(data, property)) {
      const value = data[property];
      if (typeof value === 'object' && !(value instanceof File)) {
        for (let subProperty in value) {
          if (Object.prototype.hasOwnProperty.call(value, subProperty)) {
            const formKey = `${property}[${subProperty}]`;
            formData.append(formKey, value[subProperty]);
          }
        }
      } else if (value !== '') {
        formData.append(property, value);
      }
    }
  }
  return formData;
};

const recoverPassword = (token, data) => {
  return request({
    method: 'POST',
    url: token ? `users/users/recover/${token}` : 'users/users/recover',
    data,
  });
};

const loginMotor = (email, token) => {
  return request({
    method: 'POST',
    url: `users/users/motor-sign-in`,
    data: { email, token },
  });
};

const authService = {
  login,
  registerEntity,
  recoverPassword,
  loginMotor,
};

export default authService;
